import React from "react";
import { newIcon } from "../Icon";

export const AvatarIcon = newIcon<{ active?: boolean }>(
  ({ active }) => (
    <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
      <g className="hidden-on-light-state">
        <rect width="32" height="32" rx="16" fill="#818181" />
        <path
          d="M5.97461 28.4701C7.00971 25.2484 10.0768 22.9057 13.6897 22.9057H18.3119C21.9239 22.9057 24.9916 25.2484 26.0269 28.4702C23.2854 30.6772 19.8009 31.9988 16.0079 32.0004C16.0055 32.0004 16.0031 32.0004 16.0008 32.0004C15.9984 32.0004 15.9961 32.0004 15.9937 32.0004C12.2006 31.9988 8.71611 30.6772 5.97461 28.4701Z"
          fill="#8C9EB9"
        />
        <path
          d="M16.0008 20.632C13.1339 20.632 10.8008 18.3367 10.8008 15.5162C10.8008 12.6957 13.1339 10.4004 16.0008 10.4004C18.8677 10.4004 21.2008 12.6957 21.2008 15.5162C21.2008 18.3367 18.8677 20.632 16.0008 20.632Z"
          fill="#8C9EB9"
        />
      </g>
      <g className="hidden-on-dark-state">
        <rect width="32" height="32" rx="16" fill="#DCE6F1" />
        <path
          d="M5.97363 28.4701C7.00873 25.2484 10.0758 22.9057 13.6887 22.9057H18.3109C21.9229 22.9057 24.9906 25.2484 26.0259 28.4702C23.2844 30.6772 19.8 31.9988 16.0069 32.0004C16.0045 32.0004 16.0022 32.0004 15.9998 32.0004C15.9975 32.0004 15.9951 32.0004 15.9928 32.0004C12.1996 31.9988 8.71514 30.6772 5.97363 28.4701Z"
          fill="#8C9EB9"
        />
        <path
          d="M15.9998 20.632C13.1329 20.632 10.7998 18.3367 10.7998 15.5162C10.7998 12.6957 13.1329 10.4004 15.9998 10.4004C18.8667 10.4004 21.1998 12.6957 21.1998 15.5162C21.1998 18.3367 18.8667 20.632 15.9998 20.632Z"
          fill="#8C9EB9"
        />
      </g>
    </svg>
  ),
  true,
  ["active"]
);
